'use strict';

import {SectionCtrl} from "./sectionctrl.js";
import {wpModel} from "../../models/wpmodel.js";
import {sectionModel} from "../../models/sectionmodel.js";

export class SectionA5TocCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a5_toc_before',
			on: false,
			value: null
		},
		activities: {
			key: 'a5_toc_activities',
			on: false,
			value: null
		},
		after: {
			key: 'a5_toc_after',
			on: false,
			value: null
		}
	};
	
	tocFieldsKeys = {
		a5_toc_statement: true,
		a5_toc_goal: true,
		a5_toc_planned_number: true,
		a5_toc_impacts: true
	};
	tocFields = [];
	
	workpackages = [];
	

	constructor($scope, $filter, jsDataService, $mdDialog){
		super($scope, $filter, jsDataService);
		this.$mdDialog = $mdDialog;
		if(typeof(this.section.wp) !== 'undefined'){
			this.initWP(this.section.wp);
		}
		this.collectTocFields();
	}
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
	
	collectTocFields(){
		if(typeof(this.section.fields) !== 'undefined'){
			for(let ff of this.section.fields){
				if(typeof(this.tocFieldsKeys[ff.name]) !== 'undefined' && this.tocFieldsKeys[ff.name] && this.isField(ff.name)){
					this.tocFields.push(ff);
				}
			}
		}
	}
	
	initWP(workpackages){
//		this.workpackages = [];
		for(let wp of workpackages){
			this.workpackages.push(new wpModel(wp, this.$filter, this.jsDataService));
		}
	}
	
//	initWP(workpackages){
//		for(let wp of workpackages){
//			this.rows.push(this.makeRowFromWp(wp));
//			if(typeof(wp.activities) !== 'undefined'){
//				for(let activity of Object.values(wp.activities)){
//					this.rows.push(this.makeRowFromActivity(activity));
//				}
//			}
//		}
//		
//	}
//	
//	makeRowFromWp(wp){
//		return {
//			isWp: true,
//			id: wp.id,
//			number: wp.a4_1_work_activities_no,
//			title: wp.a4_1_work_activities_name,
//			start: parseInt(wp.a4_1_work_activities_start),
//			end: parseInt(wp.a4_1_work_activities_end)
//		};
//	}
//	
//	makeRowFromActivity(activity){
//		return {
//			isWp: false,
//			id: activity.id,
//			number: activity.a4_1_work_activities_activ_no,
//			title: activity.a4_1_work_activities_activ_name,
//			start: parseInt(activity.a4_1_work_activities_activ_start),
//			end: parseInt(activity.a4_1_work_activities_activ_end)
//		};
//	}
	editWpToc(ev, wptoc){
		this.WpTocEditor(ev, wptoc);
	}

	WpTocEditor(ev, wptoc){

		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "wptoc", "section", "fieldCfg", this.wpTocEditorDialogCtrl],
			templateUrl: 'application/toc_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wptoc: wptoc,
				section: this.section,
				fieldCfg: this.fieldCfg,
			}
		}).then((tocItem) => {
			if(this.jsDataService.get('cfgTocSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgTocSaveUrl'),
					method: 'POST',
					data: tocItem
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						if(wptoc.id > 0){
							wptoc = angular.extend(wptoc, response.data.item);
						}
						else{
							this.section.wp.push(response.data.item);
						}
//						this.initWP();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgTocSaveUrl'));
			}
		}, () => {});
	}
	
	wpTocEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, wptoc, section, fieldCfg){
		$scope.wptoc = angular.copy(wptoc);
		$scope.fieldCfg = fieldCfg;

		$scope.getFieldTitle = function(name){
			if(!$scope.isField(name)){
				return '';
			}
			return fieldCfg[name].title;
		};
		$scope.getFieldLimit = function(name){
			if(!$scope.isField(name)){
				return null;
			}
			if(!fieldCfg[name].limitOn){
				return null;
			}
			return fieldCfg[name].limit;
		};
		$scope.isField = function (name){
			return (typeof(fieldCfg[name]) !== 'undefined');
		};
		$scope.isValid = function(){
			return true;
		};
		$scope.fieldRequire = function(name){
			if(!$scope.isField(name)){
				return false;
			}
			return fieldCfg[name].mandatory;
		};


		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.wptoc);
		};
	}

	autosavePostFields(){
		let post = [];
		if(this.tocFields.length>0){
			for(let tocf of this.tocFields){
				post.push(tocf.getData());
			}
		}
		return post;
	}
}

